import { forwardRef } from 'react';
import './fields.css';

// Geometry is a semantic field variant; pages supply values and events only.
export const FieldControl = forwardRef(function FieldControl({ as: Element = 'input', variant = 'field', error = false, className = '', style, ...props }, ref) {
  return <Element {...props} ref={ref} data-ds="FieldControl" data-field-variant={variant} aria-invalid={error || undefined} className={`ds-field-control ${className}`} style={style} />;
});
